/**
 * TrafficLight
 *
 * Bitdefender web-protection component, exposed via its popup imagery.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 3.4.4.
 */
import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'cfnpidifppmenkapgihekkeednfoenal';
export const trafficlight: ExtensionDefinition = {
  id: ID,
  name: "TrafficLight",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Bitdefender web-protection component, exposed via its popup imagery.",
  signals: [
    { id: 'war-img-permissions-bottom-logo-popup-dark-s', kind: 'web-accessible-resource',
      description: 'Load img/permissions_bottom_logo_popup_dark.svg via <img>, exposed to every origin.',
      weight: 1, run: () => probeImage(ID, 'img/permissions_bottom_logo_popup_dark.svg') },
    { id: 'war-img-permissions-bottom-logo-popup-light-', kind: 'web-accessible-resource',
      description: 'Load img/permissions_bottom_logo_popup_light.svg via <img>, exposed to every origin.',
      weight: 0.5, run: () => probeImage(ID, 'img/permissions_bottom_logo_popup_light.svg') },
  ],
};
